import { downloadBlob, postForFile } from './batch3Api';

export { downloadBlob };

// ── Swiggy / Zomato payout reconciliation ────────────────────────────────────

export type Provider = 'swiggy' | 'zomato';

export interface PayoutReconSummary {
  provider: string;
  summary: {
    matchedOrderIds: number;
    deliveredMatched: number;
    payoutExact: number;
    payoutWithin1: number;
    mae: number;
    providerFixedTotal: number;
    providerVariableRows: number;
  };
  variance_count: number;
  top_variances: { order_id: string; predicted: number; provider: number; diff: number; reason: string }[];
}

export function reconcilePayouts(
  erp: File,
  providerFile: File,
  provider: Provider,
  path = '/payout-reconciler/reconcile'
) {
  const form = new FormData();
  form.append('erp_file', erp);
  form.append('provider_file', providerFile);
  form.append('options', JSON.stringify({ provider }));
  return postForFile<PayoutReconSummary>(path, form, `${provider}_reconciliation_report.xlsx`, 'Reconciliation failed');
}

// ── MIS refresh ──────────────────────────────────────────────────────────────

export interface LogSummary {
  log: string;
}

export function refreshMis(master: File, sources: File[]) {
  const form = new FormData();
  form.append('master_file', master);
  sources.forEach((f) => form.append('source_files', f));
  return postForFile<LogSummary>('/mis-refresh/refresh', form, 'Derived MIS (formulas).xlsx', 'Refresh failed');
}

// ── InnControl processor ─────────────────────────────────────────────────────

export interface InnControlSummary {
  log: string;
  warnings: string;
}

export function runInnControl(file: File) {
  const form = new FormData();
  form.append('input_file', file);
  return postForFile<InnControlSummary>('/inncontrol/process', form, 'processed.xlsx', 'Processing failed');
}
